import { useInView } from 'react-intersection-observer'
import { useTranslation } from 'next-i18next'
import { makeStyles, Container } from '@material-ui/core'
import T from '../../home-new/tokens'
import Reveal from '../../home-new/Reveal'

// Bottom section of /contact?new — a full-width Google Map card of the
// SHIPPOP office, below the 3 info cards. Per product decision, this page
// carries NO contact form (same content model as the old /contact page:
// info cards + map only) — see ContactNew.js.
const useStyles = makeStyles((theme) => ({
  root: {
    padding: '40px 0 70px',
    [theme.breakpoints.down('sm')]: { padding: '28px 0 44px' },
  },
  heading: {
    fontFamily: T.font.heading,
    fontSize: 22,
    fontWeight: 700,
    color: T.color.ink,
    textAlign: 'center',
    margin: '0 0 22px',
    [theme.breakpoints.down('sm')]: { fontSize: 19, margin: '0 0 16px' },
  },
  mapCard: {
    background: T.color.surface,
    borderRadius: T.radius.xl,
    boxShadow: T.shadow.card,
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    height: 'clamp(320px, 34vw, 460px)',
    [theme.breakpoints.down('sm')]: { height: 320 },
  },
  mapFrame: { display: 'block', width: '100%', height: '100%', border: 0 },
  mapPlaceholder: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: T.color.canvasAlt,
    color: T.color.muted,
    fontFamily: T.font.body,
    fontSize: 14,
  },
}))

// Lazy-mounted Google Maps embed — the iframe only enters the DOM once the
// card scrolls near the viewport, so this third-party-heavy resource never
// competes with the LCP hero image or blocks initial page load.
const LazyMap = ({ className, frameClass, placeholderClass }) => {
  const { t } = useTranslation('contact-us')
  const [ref, inView] = useInView({ triggerOnce: true, rootMargin: '300px 0px' })
  return (
    <div className={className} ref={ref}>
      {inView ? (
        <iframe
          className={frameClass}
          title={t('new.map.iframe-title')}
          src="https://maps.google.com/maps?q=13.7577124,100.5337073&z=17&hl=th&output=embed"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      ) : (
        <div className={placeholderClass}>{t('new.map.loading')}</div>
      )}
    </div>
  )
}

const ContactMapSection = () => {
  const classes = useStyles()
  const { t } = useTranslation('contact-us')

  return (
    <section className={classes.root}>
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <h2 className={classes.heading}>{t('new.map.heading')}</h2>
        </Reveal>
        <Reveal delay={0.08}>
          <LazyMap
            className={classes.mapCard}
            frameClass={classes.mapFrame}
            placeholderClass={classes.mapPlaceholder}
          />
        </Reveal>
      </Container>
    </section>
  )
}

export default ContactMapSection
